<template>
    <b-modal
        id="copy-slu-cohort-modal"
        size="md"
        :title="$t('slu_dashboard.copy_cohort')"
        modal-class="apprentice-default-modal copy-slu-cohort"
        :ok-title="$t('common.copy')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @show="show"
        @ok="onOk">
        <div class="copy-slu-cohort">
            <div class="errors">
                <b-alert
                    v-if="hasError"
                    variant="danger"
                    show>
                    {{ $t('slu_dashboard.name_field_cannot_be_empty') }}
                </b-alert>
            </div>

            <b-form-group
                :label="$t('slu_dashboard.which_teacher_do_you_want_to_copy')"
                label-for="slu-cohort-select">
                <design-2021-apprentice-multiselect-component
                    class="slu-cohort-select"
                    id="slu-cohort-select"
                    v-model="selectedCohort"
                    label="name"
                    :options="sluCohortsIn"
                    :multiple-select="false"
                    :allow-empty="false"></design-2021-apprentice-multiselect-component>
            </b-form-group>

            <b-form-group
                class="slu-cohort-name"
                label-for="slu-cohort-name-input"
                :label="$t('common.name')">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span> </template>
                <b-form-input
                    id="slu-cohort-name-input"
                    v-model="name"
                    :placeholder="$t('slu_dashboard.grade_name')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="slu-cohort-season"
                label-for="slu-cohort-season-input"
                :label="$t('slu_dashboard.season')">
                <b-form-select
                    class="apprentice-primary-select slu-cohort-season-select"
                    id="slu-cohort-season-input"
                    v-model="season"
                    v-if="seasonsIn.length"
                    :options="seasonsIn"
                    text-field="season"
                    value-field="id">
                </b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-copy-slu-cohort-modal-component',
    props: ['seasonsIn', 'sluCohortsIn'],
    data() {
        return {
            name: '',
            seasons: this.seasonsIn,
            season: this.seasonsIn.length > 0 ? this.seasonsIn[0].id : null,
            selectedCohort: null,
            hasError: false,
        };
    },
    methods: {
        onOk(bvModal) {
            this.hasError = false;

            if (this.name === null || this.name === '') {
                this.hasError = true;
                bvModal.preventDefault();
                return;
            }
            this.alert.saving();

            let data = {
                name: this.name,
                season_id: this.season,
                slu_cohort_id: this.selectedCohort.id,
            };
            axios.post(this.routes.sluCohortCopy(), data).then(
                (response) => {
                    this.$emit('updateCohorts', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        show() {
            this.name = '';
            this.seasons = this.seasonsIn;
            this.season = this.seasonsIn.length > 0 ? this.seasonsIn[0].id : null;
        },
    },
    watch: {
        selectedCohort: function (value) {
            this.name = value.name + this.$t('common.copy');
        },
    },
};
</script>

<style scoped lang="scss"></style>
